import { createContext } from 'react';
import { Component } from '../../../services/Main/types.Component';

export const ComponentContext = createContext<Component>({} as Component);
